import React from "react";
import checkedIcon from '../../../styles/img/upsellEc/checked-icon.svg';
import UpsellEcCard from './upsell-Ec-Card'

const UpsellEcFooter = ({footer,card}) => {
  const list = footer.listItems
  const semiLength = (list.length/2)
  const leftList = list.slice(0, semiLength)
  const rightList = list.slice(semiLength)
  return(
    <footer className="upsellEc-footer">
      <h2 className="upsellEc-footer-title">{footer.footerTitle}</h2>
      <div className="upsellEc-features">
        <ul className="upsellEc-features-list">
          {leftList && leftList.length && leftList.map((item,i) => {
            return (
              <li key={i} className="upsellEc-features-listItem"><img className="upsellEc-features-checkedIcon" alt="" src={checkedIcon}/>{item}</li>
            )
          })}
        </ul>
        <ul className="upsellEc-features-list">
        {rightList && rightList.length && rightList.map((item) => {
            return (
              <li className="upsellEc-features-listItem"><img className="upsellEc-features-checkedIcon" alt="" src={checkedIcon}/>{item}</li>
            )
          })}
        </ul>
      </div>
      <UpsellEcCard card={card} />
    </footer>
  )
}
export default UpsellEcFooter;



// WEBPACK FOOTER //
// ./src/components/buy/Upsell-EC/upsell-Ec-Footer.js